import React from "react";
import { Avatar, Box, Chip, Grid, Typography } from "@mui/material";
import TableComponent from "components/grid";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TitleBar from "components/TitleBar";
import moment from "moment";

const poData = [
  // {
  //   id: 1,
  //   title: "Dock Bumpers",
  //   plannedDate: "25 JAN, 2026",
  //   actualDate: "NA",
  //   avatar: "DG",
  // },
  // {
  //   id: 2,
  //   title: "Pavers Block",
  //   //poDate: "N.A",
  //   plannedDate: "5 JAN, 2026",
  //   actualDate: "NA",
  //   avatar: "MD",
  // },
  // {
  //   id: 3,
  //   title: "DLC",
  //   //poDate: "N.A",
  //   plannedDate: "5 JAN, 2026",
  //   actualDate: "NA",
  //   avatar: "MD",
  // },
];

const BoiDues = ({data, isLoading, isError}) => {
  const tableData = data?.items || [];
  const columns = [
    {
      name: "Items",
      field: "item",
      sticky: true,
      width: "30%",
      renderer: (row) => (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#F7C7C3",
              color: "#F15744",
              fontWeight: 500,
              fontSize: 18,
            }}
          >
            {row.avatar}
          </Avatar>

          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                fontFamily: "Outfit",
                color: "#101828",
                mb: 0.5,
                maxWidth: 240,
              }}
            >
              {row.itemName}
            </Typography>

            {row.poDate && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                    fontFamily: "Outfit",
                    color: "#475467",
                  }}
                >
                  PO Date
                </Typography>

                <Chip
                  icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
                  label={row.poDate}
                  sx={{
                    height: 26,
                    fontSize: 11,
                    fontFamily: "Outfit",
                    bgcolor: "#E7E7EB",
                    color: "#433F5E",
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>
      ),
    },

    {
      name: "Planned Date",
      field: "plannedDate",
      width: "30%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.plannedDate ? moment(row.plannedDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },

    {
      name: "Actual Date",
      field: "actualDate",
      width: "30%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.actualDate ? moment(row.actualDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },
  ];

  return (
    <Grid container>
      <Grid size={12}>
        {/* <Box
          sx={{
            width: "100%",
            //borderBottom: "1px solid #E4E4E4",
            p: 1.5,
            display: "flex",
            justifyContent: "space-between",
            boxSizing: "border-box",
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 600,
                fontSize: "20px",
                letterSpacing: "0px",
                mb: 0,
              }}
            >
              Release of PO Due this Week
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 300,
                fontSize: "16px",
                letterSpacing: "0px",
                color: "#7D7F81",
              }}
            >
              Release of PO scheduled for issuance this week.
            </Typography>
          </Box>
        </Box> */}
        <Grid>
          <TitleBar title={" Release of PO Due this Week"} description={"Release of PO scheduled for issuance this week."} />
        </Grid>
        <Box>
          <TableComponent
            columns={columns}
            data={tableData}
            isLoading={isLoading}
            createSortHandler={() => { }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default BoiDues;
